import React from 'react';

// Router
import { Routes, Route } from 'react-router-dom';

// Mobx
import { inject, observer } from 'mobx-react';

// Helpers
import Helpers from '../helpers';

// Css
import '../assets/css/app.css';

// Screens
import SelectStore from './SelectStore';
import Home from './Home';
import Login from './Login';
import Page from './Page';
import Logout from './Logout';

// Profile
import Profile from './Profile';
import UpdatePasswordSettings from './Profile/password';
import UpdatePersonalSettings from './Profile/personal';
// Profile

// Documents
import Documents from './Documents';
import CreateDocument from './Documents/create';
import DocumentDetails from './Documents/details';
// Documents

// Payment Notifications
import PaymentNotifications from './PaymentNotifications';
import CreatePaymentNotification from './PaymentNotifications/create';
import PaymentNotificationDetails from './PaymentNotifications/details';
// Payment Notifications

// Trainings
import Trainings from './Trainings';
import ViewTraining from './Trainings/view';
// Trainings

// Products
import Products from './Products';
import ProductDetails from './Products/details';
import ProductCategory from './Products/category';
// Products

// Shopping Cart
import ShoppingCart from './ShoppingCart';
// Shopping Cart

// Orders
import Orders from './Orders';
import OrderDetails from './Orders/details';
// Orders
// Screens

@inject('AuthStore')
@observer

export default class StartProvider extends React.Component<any> {
    state: any = {
        appStatus: false,
    };

    componentDidMount() {
        this.startFunction();
    }

    startFunction = async () => {
        await Helpers.setSettings();
        await Helpers.loginControl();

        Helpers.startSocket();

        this.setState({
            appStatus: true
        })
    }

    render() {
        return (
            this.state.appStatus ?
                <Routes>
                    <Route path="/" element={<SelectStore />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/:slug" element={<Page />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/logout" element={<Logout />} />

                    {/* Profile */}
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/profile/password" element={<UpdatePasswordSettings />} />
                    <Route path="/profile/personal" element={<UpdatePersonalSettings />} />
                    {/* Profile */}

                    {/* Documents */}
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/documents/create" element={<CreateDocument />} />
                    <Route path="/documents/:id" element={<DocumentDetails />} />
                    {/* Documents */}

                    {/* Payment Notifications */}
                    <Route path="/paymentnotifications" element={<PaymentNotifications />} />
                    <Route path="/paymentnotifications/create" element={<CreatePaymentNotification />} />
                    <Route path="/paymentnotifications/:id" element={<PaymentNotificationDetails />} />
                    {/* Payment Notifications */}

                    {/* Trainings */}
                    <Route path="/trainings" element={<Trainings />} />
                    <Route path="/trainings/:id" element={<ViewTraining />} />
                    {/* Trainings */}

                    {/* Products */}
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:id" element={<ProductDetails />} />
                    <Route path="/products/category/:id" element={<ProductCategory />} />
                    {/* Products */}

                    {/* ShoppingCart */}
                    <Route path="/shoppingcard" element={<ShoppingCart />} />
                    {/* ShoppingCart */}

                    {/* Orders */}
                    <Route path="/orders" element={<Orders />} />
                    <Route path="/orders/:id" element={<OrderDetails />} />
                    {/* Orders */}
                </Routes>
                :
                <div className="w-full h-screen flex flex-col justify-center items-center">
                    <img
                        src={require("../assets/images/loading.gif")}
                        className="w-10"
                    />
                </div>
        )
    }
}